//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
  data() {
    return {
      detail: {
        title: '',
        createTime: '',
        content: ''
      },
      loading: false,
      id: '',
      tagList: []
    }
  },
  components: {
    uParse,
    uniLoadMore
  },
  onLoad(event) {
    this.id = event.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/advisory/queryAdvisoryDetails',
        data: {
          advisoryDetailsCode: this.id
        }
      })
        .then(result => {
          this.loading = false
          this.detail = result.data
          this.tagList = result.data.advisoryDetailsLabelsVos



        }).catch(result => {

        })
    }
  }
}
